export const ACTIVE = "active-arena";